import React from 'react';

import type {LicenseType} from 'nutshell-graphql-types';
import type {GetLicenseOverview_licenseOverview_instanceLicenses as LicenseInfo} from 'nutshell-graphql-types';

import {LicenseSwitchHorizontal} from './license-switch-horizontal';
import {LicenseSwitchVertical} from './license-switch-vertical';

type Props = {
    licenseType: LicenseType;
    licenseInfo: LicenseInfo;
    isOn: boolean;
    purchaseLink?: string | null;
    infoLink?: string | null;
    isHorizontal?: boolean;
    handleSwitchToggle: (licenseType: LicenseType) => void;
};

export function LicenseSwitch(props: Props) {
    const maxSeatsReached =
        !props.licenseInfo.isUnlimited && props.licenseInfo.numUsed >= props.licenseInfo.numBought;

    const isDisabled =
        maxSeatsReached || !(props.licenseInfo.isPurchased || props.licenseInfo.isUnlimited);

    return props.isHorizontal ? (
        <LicenseSwitchHorizontal
            maxSeatsReached={maxSeatsReached}
            isDisabled={isDisabled}
            {...props}
        />
    ) : (
        <LicenseSwitchVertical
            maxSeatsReached={maxSeatsReached}
            isDisabled={isDisabled}
            {...props}
        />
    );
}
